import { Component, input, Input } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../../openapi';
import { AccordionGroupComponent } from '../../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../../common/accordion-item/accordion-item.component';
import { EntityLabelPipe } from '../../../../../../../../pipes/applicant-label.pipe';
import {
  OpinionOnIssuingADecisionInvestorItemPreviewComponent
} from '../opinion-on-issuing-a-decision-investor-item-preview/opinion-on-issuing-a-decision-investor-item-preview.component';

@Component({
  selector: 'app-opinion-on-issuing-a-decision-investor-preview',
  standalone: true,
  imports: [
    AccordionGroupComponent,
    AccordionItemComponent,
    EntityLabelPipe,
    OpinionOnIssuingADecisionInvestorItemPreviewComponent
  ],
  templateUrl: './opinion-on-issuing-a-decision-investor-preview.component.html'
})
export class OpinionOnIssuingADecisionInvestorPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public application = input<ApplicationAppEntityApplicationRead | null>(null);
}
